<template>
  <div class="modal"
       v-bind:class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Cite this Page</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <content>
          <p>Lorem ipsum dolor sic amet.</p>
        </content>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Copy to Clipboard</button>
        <button class="button" @click="closeModal">Cancel</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'citation',
  props: ['isActive'],
  methods: {
    closeModal () {
      if (this.isActive) {
        this.$emit('close-citation')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Citation.vue?7d1963fe